import { User } from '@/shared/model/types';

import { Dropdown } from './types';

const { Action, DropdownItemType } = Dropdown;

const { ITEM, DIVIDER } = DropdownItemType;
const { COPY, DELETE, EDIT, NONE } = Action;

const menuItemList: Set<Dropdown.DropdownItem> = new Set([
  { type: ITEM, event: EDIT, label: 'Редактировать', icon: 'edit' },
  { type: DIVIDER, event: NONE },
  { type: ITEM, event: DELETE, label: 'Удалить', icon: 'delete' },
]);

const menuItemListAll: Set<Dropdown.DropdownItem> = new Set([
  { type: ITEM, event: COPY, label: 'Копировать ссылку', icon: 'link' },
  ...menuItemList,
]);

const { AUTHOR, VISITOR } = User.ROLE;
// allowed actions by role map
const roleMap = new Map<User.ROLE, Set<Dropdown.Action | undefined>>([
  [AUTHOR, new Set([COPY, DELETE, EDIT, NONE])],
  [VISITOR, new Set([COPY])],
]);

const getMenuItemList = (isFull: boolean, userRole: User.ROLE) => {
  const baseList = isFull ? menuItemListAll : menuItemList;

  // Filter list according persission by role model
  return new Set([...baseList].filter((i) => roleMap.get(userRole)?.has(i.event)));
};

export { getMenuItemList, Action, DropdownItemType };
